// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Y4B4AdiWAleVMP {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 600px;\n}\n.Y4B4AdiWAleVMP > button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n}\n.Y4B4AdiWAleVMP div {\n  display: block;\n  text-align: center;\n  height: 100%;\n}\n.Y4B4AdiWAleVMP div h4 {\n  font-size: 20px;\n  margin: 20px 16px 24px;\n}\n.Y4B4AdiWAleVMP div p {\n  font-size: 16px;\n  margin: 0 0 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "Y4B4AdiWAleVMP"
};
export default ___CSS_LOADER_EXPORT___;
